import { render, staticRenderFns } from "./dialogStartNode.vue?vue&type=template&id=08783146&scoped=true&"
import script from "./dialogStartNode.vue?vue&type=script&lang=js&"
export * from "./dialogStartNode.vue?vue&type=script&lang=js&"
import style0 from "./dialogStartNode.vue?vue&type=style&index=0&id=08783146&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08783146",
  null
  
)

export default component.exports